// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Osus","delete":"styles_delete__1JiMv","update":"styles_update__3YWqc","add":"styles_add__2imVj"};